
export default ({
  name,
  treatment,
  first_name: firstName,
  last_name: lastName,
  mothers_last_name: secondLastName,
  username }) => {
  return `${treatment || ''} ${firstName || name || username} ${lastName || ''} ${secondLastName || ''}`
}
